import { Button, Modal, TextBlock, Title } from '@skillarea/lib-frontend';
import { useTranslation } from 'react-i18next';

import styles from './ChestUnlockedModal.module.scss';

export type TChestUnlockedModalProps = {
  ctaLabel?: string;
  isCtaDisabled?: boolean;
  isOpen: boolean;
  onClose: () => void;
  onGoToRewards: () => void;
};

export function ChestUnlockedModal({
  ctaLabel,
  isCtaDisabled = false,
  isOpen,
  onClose,
  onGoToRewards,
}: TChestUnlockedModalProps) {
  const { t } = useTranslation('modals');
  const modalDescription = t('chestUnlocked.modalDescription');
  const resolvedCtaLabel = ctaLabel ?? t('chestUnlocked.cta');

  return (
    <Modal
      classNameModal={styles.modal}
      description={modalDescription}
      isOpen={isOpen}
      onBeforeClose={onClose}
      size="l"
      title={t('chestUnlocked.title')}
    >
      <div className={styles.content} data-testid="chest-unlocked-modal">
        <div aria-hidden="true" className={styles.chestImage}></div>
        <header className={styles.header}>
          <Title as="h2" className={styles.title} color="contrast">
            {t('chestUnlocked.heading')}
          </Title>

          <TextBlock className={styles.description} color="contrast">
            {t('chestUnlocked.description')}
          </TextBlock>
        </header>

        <Button
          className={styles.actionButton}
          color="accent"
          data-testid="chest-unlocked-modal-cta"
          disabled={isCtaDisabled}
          onClick={onGoToRewards}
          size="s"
          type="button"
          variant="filled"
        >
          {resolvedCtaLabel}
        </Button>
      </div>
    </Modal>
  );
}
